import React from "react";
import { Text, useToken } from "@gluestack-ui/themed"

const coloresPermitidos = {
    red: "$red600",
    blue: "$blue600",
    green: "$green600",
    yellow: "$yellow600",
    gray: "$light500",
    black: "$black",
};

// 🔧 Aplica estilos como negrita, cursiva, subrayado, tachado
function aplicarEstilo(texto, keyBase,color) {
    const partes = texto.split(/(\~\~.*?\~\~|__.*?__|\*\*.*?\*\*|_.*?_)/);

    return partes.map((parte, i) => {
        if (/^\~\~(.*?)\~\~$/.test(parte)) {
            return (
                <Text key={`${keyBase}-del-${i}`} textDecorationLine="line-through" color={color}>
                    {parte.slice(2, -2)}
                </Text>
            );
        } else if (/^__(.*?)__$/.test(parte)) {
            return (
                <Text key={`${keyBase}-u-${i}`} textDecorationLine="underline" color={color}>
                    {parte.slice(2, -2)}
                </Text>
            );
        } else if (/^\*\*(.*?)\*\*$/.test(parte)) {
            return (
                <Text key={`${keyBase}-b-${i}`} fontWeight="bold" color={color}>
                    {parte.slice(2, -2)}
                </Text>
            );
        } else if (/^_(.*?)_$/.test(parte)) {
            return (
                <Text key={`${keyBase}-i-${i}`} fontStyle="italic" color={color}>
                    {parte.slice(1, -1)}
                </Text>
            );
        } else {
            return <Text key={`${keyBase}-${i}`} color={color}>
                {parte}
            </Text>;
        }
    });
}

// 🧠 Función principal
export function MarkdownText({ children, parser=false} : {children:string,parser:boolean}) {
    if(parser==false)
            return <Text>{children}</Text>
    // Obtenemos el valor numérico del token $md desde el tema
    const fontSizeBase = 16;
    const texto = children;
    const bloques = texto.split(/(?:\\n|\n)/); // soporta \n y \\n
console.log("MDText")
    return (
        <>
            {bloques.map((bloque, bloqueIndex) => {
                const partes = bloque.split(/(\{\{.*?\}\})/);

                const elementos = partes.map((parte, i) => {
                    const match = parte.match(/\{\{([a-zA-Z0-9+-]+):(.*?)\}\}/s);

                    if (match) {
                        const modificador = match[1];
                        const contenido = match[2];

                        // Tamaño de texto ajustado
                        if (modificador === "+1" || modificador === "-1") {
                            const cambio = modificador === "+1" ? 1 : -1;
                            return (
                                <Text
                                    key={`size-${bloqueIndex}-${i}`}
                                    fontSize={fontSizeBase + cambio}
                                >
                                    {aplicarEstilo(contenido, `s-${bloqueIndex}-${i}`)}
                                </Text>
                            );
                        }

                        // Color
                        const colorClave = modificador.toLowerCase();
                        const color = coloresPermitidos[colorClave] || "$black";

                        return (
                            <Text key={`color-${bloqueIndex}-${i}`} color={color}>
                                {aplicarEstilo(contenido, `c-${bloqueIndex}-${i}`,color)}
                            </Text>
                        );
                    } else {
                        return (
                            <Text key={`plain-${bloqueIndex}-${i}`}>
                                {aplicarEstilo(parte, `p-${bloqueIndex}-${i}`)}
                            </Text>
                        );
                    }
                });

                return (
                    <Text key={`bloque-${bloqueIndex}`} flexWrap="wrap">
                        {elementos}
                        {bloqueIndex < bloques.length - 1 && "\n"}
                    </Text>
                );
            })}
        </>
    );
}
